<template>
  <div>
    <div v-if="!isInMonday">
      <Navbar />
    </div>
    <v-container>
      <v-btn @click="onBtnCheckout" class="primary mt-2">Create New Pool</v-btn>

      <v-divider class="my-2" />
      
      <div class="display-2 font-weight-thin">
        Your pools
      </div>
      <div class="flex-grow-1 d-flex flex-column">
        <v-card
          outlined
          class="pa-8 ma-4 d-flex flex-column"
          style="width:100%; height: 20rem; min-height: 200px; max-height: 40rem;"
        >
          <div class="display-1 font-weight-light grey--text">
            No pools found
          </div>
        </v-card>
      </div>

    </v-container>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import * as fb_functionsSvc from "@/services/fb_functionsSvc";

export default {
  components: {
    Navbar,
  },
  methods: {
    async testFbFunction() {
      console.log("foo");
      let q = await fb_functionsSvc.testFbFunc();
      console.log(q);
    },
    async onBtnCheckout() {
      console.log("starting checkout...");
      let res = await fb_functionsSvc.stripe_checkoutSessionCreateEdPt();
      console.log(res.url);
      console.log("redirecting...");
      await this.$utils.wait(2000);
      window.open(res.url, '_blank');
      console.log("done");
    }
  },
};
</script>

<style scoped></style>
